import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import GiftOrderContext from '@providers/GiftOrderProvider/GiftOrderContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

function Sender() {
    const { handleChange, state } = useContext(GiftOrderContext);
    const { t } = useTranslation('gift');
    return (
        <Column fullWidth spacing={12}>
            <Text color={colors.gray7} fontWeight='bold' size='2xl'>
                {t('giftOrder.senderTitle')}
            </Text>
            <Column fullWidth spacing={20}>
                <TextField placeholder={t('giftOrder.senderNamePlaceholder')}
                    onChange={handleChange}
                    name='userName' />
                <TextField placeholder={t('giftOrder.senderPhonePlaceholder')}
                    inputMode='numeric'
                    value={state.userPhone}
                    maxLength={13}
                    onChange={handleChange}
                    name='userPhone' />
            </Column>
        </Column>
    );
}

export default Sender;
